export const DOCUMENT_TYPE_PRODUCT = 'commerce.product';
export const OBJECT_TYPE_PRODUCT_VARIANT = 'commerce.productVariant';
